import { Container, Row, Col } from "react-bootstrap";
import menuImg from "../../assets/img/smash_burger.jpg";
import scheduleImg from "../../assets/img/truck.jpg";
import cateringImg from "../../assets/img/shrimp_pasta.jpg";
import { PageHeader } from "../PageHeader";
import { HomeCard } from "../HomeCard";

const HOME_CARDS = [
  {
    image: menuImg,
    title: "Explore the Menu",
    text:
      "Discover our delicious offerings, from classic favorites to unique creations. Fresh, flavorful, and always bougie!",
    linkTo: "/menu",
    linkLabel: "See the menu",
  },
  {
    image: scheduleImg,
    title: "Find Our Schedule",
    text:
      "See where the Lil Bougie Foodie truck will be next! Check our schedule and never miss a stop near you.",
    linkTo: "/schedule",
    linkLabel: "View schedule",
    imageRight: true,
  },
  {
    image: cateringImg,
    title: "Catering & Events",
    text:
      "Make your next event unforgettable! Book our food truck for catering and treat your guests to a bougie experience.",
    linkTo: "/catering",
    linkLabel: "Book catering",
  },
];

export const Home = () => (
  <section className="banner" id="home">
    <Container>
      <Row className="justify-content-center">
        <Col xs={12}>
          <PageHeader
            className="home-header"
            tagline="The Lil Bougie Foodie"
            subtitle={
              <>
                Welcome to the Lil Bougie Foodie food truck!
                <br />
                Explore our menu, check our schedule, or book catering for your next event.
              </>
            }
            subtitleClassName="home-intro"
          />
        </Col>
      </Row>
      <Row className="justify-content-center">
        {HOME_CARDS.map((card) => (
          <Col xs={12} className="mb-4" key={card.linkTo}>
            <HomeCard {...card} />
          </Col>
        ))}
      </Row>
    </Container>
  </section>
);
